"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _react2 = require("@chakra-ui/react");

var _Line = require("../constants/Line");

var _BlockRenderer = require("./BlockRenderer");

var _RendererContext = require("./RendererContext");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

function RendererChakra() {
  var _document$lines;

  var _useContext = (0, _react.useContext)(_RendererContext.RendererContext),
      document = _useContext.document;

  return __jsx(_react["default"].Fragment, null, document == null ? void 0 : (_document$lines = document.lines) == null ? void 0 : _document$lines.map(function (line, idLine) {
    var _line$backgroundPosit;

    return __jsx(_react2.Flex, {
      className: "renderer",
      style: {
        display: "flex"
      },
      backgroundColor: line.backgroundType === _Line.BACKGROUND_TYPES.COLOR && line.backgroundFillWidth ? line.backgroundColor : null,
      backgroundImage: line.backgroundType === _Line.BACKGROUND_TYPES.IMAGE && line.backgroundFillWidth ? "url(".concat(line.backgroundSrc, ")") : null,
      backgroundSize: line.backgroundRepeat === "no-repeat" && "cover",
      backgroundPosition: (_line$backgroundPosit = line.backgroundPosition) != null ? _line$backgroundPosit : "center center",
      backgroundRepeat: line.backgroundRepeat,
      key: idLine
    }, __jsx(_react2.Flex, {
      flex: "1",
      flexDirection: {
        base: line.layoutMobile,
        lg: "row"
      },
      alignItems: line.alignItems,
      paddingTop: "".concat(line.paddingTop, "px"),
      paddingRight: "".concat(line.paddingRight, "px"),
      paddingBottom: "".concat(line.paddingBottom, "px"),
      paddingLeft: "".concat(line.paddingLeft, "px"),
      backgroundColor: line.backgroundType === _Line.BACKGROUND_TYPES.COLOR && !line.backgroundFillWidth ? line.backgroundColor : null,
      backgroundImage: line.backgroundType === _Line.BACKGROUND_TYPES.IMAGE && !line.backgroundFillWidth ? "url(".concat(line.backgroundSrc, ")") : null,
      backgroundSize: line.backgroundRepeat === "no-repeat" && "cover",
      backgroundPosition: "center",
      backgroundRepeat: line.backgroundRepeat,
      margin: "auto",
      pos: "relative"
    }, line.columns.map(function (column, idColumn) {
      return __jsx(_react2.Box, {
        display: "flex",
        flexDirection: "column",
        width: {
          base: ["column", "column-reverse"].includes(line.layoutMobile) ? "100%" : line.columnsPreset.split(" ")[idColumn],
          lg: line.columnsPreset.split(" ")[idColumn]
        },
        key: idColumn
      }, column.map(function (block, idBlock) {
        var _block$backgroundPosi;

        return __jsx(_react2.Box, {
          display: block.allowHorizontalPositioning ? "flex" : "block",
          justifyContent: block.alignment,
          key: idBlock
        }, __jsx(_react2.Box, {
          display: block.allowHorizontalPositioning ? "inline-block" : "block",
          width: block.fullWidth ? "100%" : "auto",
          position: "relative",
          paddingTop: "".concat(block.paddingTop, "px"),
          paddingRight: "".concat(block.paddingRight, "px"),
          paddingBottom: "".concat(block.paddingBottom, "px"),
          paddingLeft: "".concat(block.paddingLeft, "px"),
          backgroundColor: block.backgroundType === _Line.BACKGROUND_TYPES.COLOR ? block.backgroundColor : null,
          backgroundImage: block.backgroundType === _Line.BACKGROUND_TYPES.IMAGE ? "url(".concat(block.backgroundSrc, ")") : null,
          backgroundSize: block.backgroundRepeat === "no-repeat" && "cover",
          backgroundPosition: (_block$backgroundPosi = block.backgroundPosition) != null ? _block$backgroundPosi : "center center",
          backgroundRepeat: block.backgroundRepeat
        }, __jsx(_BlockRenderer.BlockRenderer, {
          block: block
        })));
      }));
    })));
  }));
}

RendererChakra.displayName = "RendererChakra";
var _default = RendererChakra;
exports["default"] = _default;